import { getOSSData } from './request';

let OSSInfo = null;
const xhrList = {};

function uuid() {
  const str = Array(...Array(4)).reduce(
    a =>
      a +
      Math.random()
        .toString(36)
        .slice(2, 8),
    ''
  );
  return str
    .split('')
    .map(char => (Math.floor(Math.random() * 2) ? char.toUpperCase() : char))
    .join('');
}

function getFileSize(size) {
  const units = ['B', 'KB', 'MB', 'GB'];
  let fileSize = Number(size);
  let unitIdx = 0;

  while (fileSize > 511 && units[unitIdx]) {
    fileSize /= 1024;
    unitIdx += 1;
  }
  return `${Number(fileSize.toFixed(1))} ${units[unitIdx]}`;
}

function getFileInfo(file, fileUid) {
  const fileInfo = {
    name: file.name,
    size: getFileSize(file.size),
    fileId: fileUid || uuid(),
    fileSize: file.size,
    fileType: file.name.split('.').pop(),
  };
  fileInfo.fileName = file.name.replace(new RegExp(`.${fileInfo.fileType}$`), '');
  return fileInfo;
}

class Uploader {
  _upload(file, data = {}, options = {}) {
    return new Promise((resolve, reject) => {
      const oss = OSSInfo;
      const xhr = new XMLHttpRequest();
      const formData = new FormData();
      const fileUid = uuid();

      if (file.size > 1024 * 1024 * 10) {
        // file must be smaller than 10M
        reject('exceed_file_size');
        return;
      }

      const fileInfo = getFileInfo(file, fileUid);
      if (typeof options.onStart === 'function') {
        options.onStart(fileInfo);
      }

      Object.keys(data).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          formData.append(key, data[key]);
        }
      });

      if (xhr.upload) {
        xhr.upload.onprogress = (e) => {
          e.fileId = fileUid;
          if (e.total > 0) {
            e.percent = Math.round(e.loaded / e.total * 10000) / 100;
          }
          if (typeof options.onProgress === 'function') {
            options.onProgress(e);
          }
        };
      }

      const reg = /.*\.(\w+)$/;
      const { fileName = '' } = file;
      let fileExt = null;
      const nameReg = fileName.match(reg);
      if (nameReg) {
        fileExt = nameReg[1];
      }
      fileExt = fileExt ? `.${fileExt}` : '';
      const key = `${oss.keyPrefix + Date.now()}_${fileUid}${fileExt}`.replace(/^[/\\]+/, '');

      formData.append('x-oss-object-acl', 'public-read');
      formData.append('OSSAccessKeyId', oss.accessId);
      formData.append('policy', oss.policy);
      formData.append('signature', oss.signature);
      formData.append('key', key);
      formData.append('file', file);

      xhr.onerror = (e) => {
        this.abortUpload = null;
        delete xhrList[fileUid];
        reject(e);
      };

      xhr.onload = () => {
        if (xhr.status < 200 || xhr.status >= 300) {
          const err = new Error('Uploading failed, please retry.');
          err.status = xhr.status;
          reject(err);
        } else {
          delete xhrList[fileUid];
          resolve({
            ...fileInfo,
            url: `${oss.host}/${key}`,
            fileId: fileUid,
          });
        }
      };

      xhr.open('post', oss.host);
      // xhr.withCredentials = true;

      xhr.send(formData);
      xhrList[fileUid] = xhr;
    });
  }

  abortUpload = (fileUid) => {
    if (xhrList[fileUid]) {
      xhrList[fileUid].abort();
      delete xhrList[fileUid];
      return true;
    }
    return false;
  };

  uploadFile = (file, data, options) => {
    if (!OSSInfo || OSSInfo.expire * 1000 < Date.now()) {
      return getOSSData()
        .then((res) => {
          if (res.status === 200) {
            OSSInfo = res.data;
            return this._upload(file, data, options);
          }
          throw new Error('Get OSS info failed!');
        })
        .catch((err) => {
          throw err;
        });
    }
    return this._upload(file, data, options);
  };
}

export default Uploader;
export { getFileSize, getFileInfo };



// WEBPACK FOOTER //
// ./src/utils/upload.js